import React, { createContext, useContext, useState } from 'react';

const AppContext = createContext();

export const useAppContext = () => useContext(AppContext);

export const AppProvider = ({ children }) => {
    const [someState, setSomeState] = useState(null);

    return (
        <AppContext.Provider value={{ someState, setSomeState }}>
            {children}
        </AppContext.Provider>
    );
};
